import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from '../../../configuration/services';
import { CartaServices } from '../../services';
import { CartaCreateSelectTypePage } from '../../carta-create/carta-create-select-type/carta-create-select-type';
import { CartaPageCustomizeTemplatPage } from './carta-page-customize-template/carta-page-customize-template';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';
import { TranslateService } from '@ngx-translate/core';
import { QRServices } from '../../../services/qrServices';


/**
 * Generated class for the CartaPartialCustomizeOptionsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-carta-partial-customize-options',
  templateUrl: 'carta-partial-customize-options.html',
})
export class CartaPartialCustomizeOptionsPage {

  @Input() carta_uid: any;
  page_order_show: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    private http: HttpClient,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    public cartaServices: CartaServices,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public qrServices: QRServices) {
  }

  async printPages() {
    this.globals.GAtrackView('Cartas', 'Cartas - Print', this.globals.restaurant.email, 'View', 'Print carta', 'Cartas', '');

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-imprimiendo-carta')
    });
    loadingPopup.present();

    //Format values
    var currency_symbol = this.globals.currency_symbol;
    var logo_format;

    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //Watermark comprovation
    var watermark = 'false';
    if (this.globals.checkLimitsByLicense('menus', 'watermark')) {
      watermark = 'true';
    }

    //Format object menu for POST send
    var carta_send = this.cartaServices.carta_tmp;

    this.http.post(this.globals.api_path + 'carta/a4',
      {
        carta: carta_send,
        currency_symbol: currency_symbol,
        logo: logo_format,
        lang: this.cartaServices.carta_lang,
        watermark: watermark,
        percent: this.cartaServices.percent,
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(String(res['file']));
        } else {
          window.open(String(res['file']), '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });

  }

  changeLang(lang) {
    this.cartaServices.carta_lang = lang;
  }


  openCartaStyle(carta_name, type) {
    this.navCtrl.push(CartaCreateSelectTypePage, {
      update_state: true,
      carta_uid: this.carta_uid,
      carta_name: carta_name,
      type: type,
    })
  }


  async updateIonToggle(type, value) {
    switch (type) {
      case 'hide_footer': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'hide_footer': value,
        });
        break;
      }
      case 'show_caption': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_caption': value,
        });
        break;
      }
      case 'show_description': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_description': value,
        });
        break;
      }
      case 'show_enumerate_elements': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_enumerate_elements': value,
        });
        break;
      }
      case 'show_enumerate_pages': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_enumerate_pages': value,
        });
        break;
      }
      case 'show_logo': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_logo': value,
        });
        break;
      }
      case 'show_price': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_price': value,
        });
        break;
      }
      case 'show_price_half': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_price_half': value,
        });
        break;
      }
      case 'show_price_tapa': {
        await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
          'show_price_tapa': value,
        });
        break;
      }

    }
  }

  async openNewPage() {

    var last_key = Object.keys(this.cartaServices.carta_tmp.pages)[Object.keys(this.cartaServices.carta_tmp.pages).length - 1];
    if (last_key == undefined) {
      last_key = '-1';//Iniciamos a 0 si esta undefined
    }

    this.cartaServices.carta_tmp.pages[Number(last_key) + 1] = {
      number: this.cartaServices.carta_tmp.pages[Number(last_key)].number + 1,
      sections: {
        0: {
          name: '',
          order: 1,
          font_size_sname: 18,
          font_family_sname: 'Arial',
          font_color_sname: '#000',
          text_align_sname: 'left',
          font_size_ename: 18,
          font_family_ename: 'Arial',
          font_color_ename: '#000',
          font_size_edescription: 18,
          font_family_edescription: 'Arial',
          font_color_edescription: '#000',
          elements: {},
        }
      },
    }

    await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
      pages: this.cartaServices.carta_tmp.pages,
    });

    this.cartaServices.page_active = this.cartaServices.carta_tmp.pages[Number(last_key)].number + 1;
    this.cartaServices.cleanEdit();
  }

  async deletePage() {
    //convert to array
    let arr = [];
    for (let k in this.cartaServices.carta_tmp.pages) {
      arr.push(this.cartaServices.carta_tmp.pages[k]);
    }

    //si hay una pagina no se borra
    if (arr.length > 1) {
      //delete
      arr.forEach((item, index) => {
        if (item.number === this.cartaServices.page_active) {
          arr.splice(index, 1);
          if (item.number === 1) {
            this.cartaServices.page_active = 1;
          } else {
            this.cartaServices.page_active -= 1;
          }
        }
      });

      //dar numero en orden las otras paginas
      var count = 1;
      arr.forEach((item, index) => {
        item.number = count;
        count++;
      });

      //create of array to object
      const obj = {};
      arr.forEach((item, index) => {
        obj[index] = item;
      })
      this.cartaServices.carta_tmp.pages = obj;

      //no hi ha res dins object reiniciar
      if (Object.keys(this.cartaServices.carta_tmp.pages).length == 0) {
        this.cartaServices.carta_tmp.pages = {};
      }

      //update para que quede eliminado
      await this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
        pages: this.cartaServices.carta_tmp.pages,
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-no-puedes-eliminar-todas-paginas'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }


  }

  openOrderPages() {
    if (!this.page_order_show) {
      this.page_order_show = true;
    } else {
      this.page_order_show = false;
    }
  }

  updatePageOrder() {

    var _obj = {};
    for (var i = 0; this.cartaServices.pages_array_tmp.length > i; i++) {
      _obj[i] = {
        number: i + 1,
        sections: this.cartaServices.pages_array_tmp[i].sections,
      };
    }
    this.cartaServices.afs.collection('cartas').doc(this.carta_uid).update({
      'pages': _obj,
    });
    this.cartaServices.cleanEdit();
    this.openOrderPages();
  }

  openTemplates() {
    this.navCtrl.push(CartaPageCustomizeTemplatPage, {
      carta_uid: this.carta_uid
    })
  }

  openLogo() {
    this.globals.side_menu_config_active = 'images';
    this.navCtrl.push(ConfigurationImagesPage);
  }

  reorderPages(indexes) {
    let element = this.cartaServices.pages_array_tmp[indexes.from];
    this.cartaServices.pages_array_tmp.splice(indexes.from, 1);
    this.cartaServices.pages_array_tmp.splice(indexes.to, 0, element);
  }

  async share() {
    this.globals.GAtrackView('Cartas', 'Cartas - Share', this.globals.restaurant.email, 'View', 'Share carta', 'Cartas', '');

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-compartiendo-carta')
    });
    loadingPopup.present();

    //Format values
    var currency_symbol = this.globals.currency_symbol;
    var logo_format;

    if (!this.globals.logo_url) {
      logo_format = '';
    } else {
      await this.globals.logo_url.subscribe(data => {
        logo_format = data;
      });
    }

    //Watermark comprovation
    var watermark = 'false';
    if (this.globals.checkLimitsByLicense('menus', 'watermark')) {
      watermark = 'true';
    }

    //Format object carta for POST send
    var carta_send = this.cartaServices.carta_tmp;

    this.http.post(this.globals.api_path + 'cartaxxss',
      {
        carta: carta_send,
        currency_symbol: currency_symbol,
        logo: logo_format,
        lang: this.cartaServices.carta_lang,
        watermark: watermark,
        percent: this.cartaServices.percent,
      }, {})
      .subscribe(res => {
        if (this.globals.so_mobile) {
          window.location.assign(this.globals.api_path + 'share/menu/' + String(res['file']) + '/' + this.cartaServices.carta_lang);
        } else {
          window.open(this.globals.api_path + 'share/menu/' + String(res['file']) + '/' + this.cartaServices.carta_lang, '_blank');
        }
        loadingPopup.dismiss();
      }, error => {
        loadingPopup.dismiss();
      });
  }

  async generateGR() {
    this.qrServices.generateMenuCartaGR(this.cartaServices.carta_tmp.UID, 'carta');
  }

}



// WEBPACK FOOTER //
// ./src/pages/carta/carta-view/carta-partial-customize-options/carta-partial-customize-options.ts